import { styled } from "../../Theme";
import { ButtonPill } from "../../components";
import { pickTextColorBasedOnBgColor } from "../../utils";

export const IdentityForm = styled.form`
  display: flex;
  flex-direction: column;
`;

export const ValidateButton = styled(ButtonPill);
